// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"db914b41","139":"075a09d6","180":"ad4af24e","496":"0ed68de2","653":"02d8f422","665":"f18b3800","787":"137d9628","821":"11c301d7","941":"3928f0c7"}[chunkId] + ".chunk.js";
};